import { useEffect } from 'react';

function setFreshchatDarkMode(isDark) {
  const iframe =  document.querySelector('.fc-widget-normal');
  if (iframe) {
    iframe.style.filter = isDark ? 'brightness(0.5)' : '';
    iframe.style.transition = 'filter 0.3s ease';
    iframe.style.pointerEvents = isDark ? 'none' : 'auto';
  }
}

function useFreshchatDarkMode() {
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const modals = document.querySelectorAll('.ant-modal-wrap');
      let isAnyModalVisible = false;

      modals.forEach(modal => {
        const style = window.getComputedStyle(modal);
        if (
          style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          parseFloat(style.opacity) > 0
        ) {
          isAnyModalVisible = true;
        }
      });
      console.log('isAnyModalVisible:', isAnyModalVisible);
      setFreshchatDarkMode(isAnyModalVisible);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class'],
    });

    return () => observer.disconnect();
  }, []);
}

export default useFreshchatDarkMode;
